const GET_RESTAURANT_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors du chargement des paramètres du restaurant.";
export const GET_RESTAURANT_SETTINGS_ERROR = GET_RESTAURANT_SETTINGS_ERROR_TEXT;

const GET_CLOSED_DAYS_ERROR_TEXT = "Une erreur est survenue lors du chargement des jours de fermeture.";
export const GET_CLOSED_DAYS_ERROR = GET_CLOSED_DAYS_ERROR_TEXT;

const GET_SHIFTS_ERROR_TEXT = "Une erreur est survenue lors du chargement des disponibilités.";
export const GET_SHIFTS_ERROR = GET_SHIFTS_ERROR_TEXT;

const GET_OPENING_HOURS_ERROR_TEXT = "Une erreur est survenue lors du chargement des horaires du restaurant.";
export const GET_OPENING_HOURS_ERROR = GET_OPENING_HOURS_ERROR_TEXT;

const GET_DEFAULT_SHIFTS_ERROR_TEXT = "Une erreur est survenue lors du chargement des horaires de réservation.";
export const GET_DEFAULT_SHIFTS_ERROR = GET_DEFAULT_SHIFTS_ERROR_TEXT;

const GET_MAX_SEATS_ERROR_TEXT = "Une erreur est survenue lors du chargement du nombre de couverts maximum.";
export const GET_MAX_SEATS_ERROR = GET_MAX_SEATS_ERROR_TEXT;

const GET_CURRENT_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors du chargement de votre réservation.";
export const GET_CURRENT_RESERVATION_ERROR = GET_CURRENT_RESERVATION_ERROR_TEXT;

const CHECK_AVAILABILITY_ERROR_TEXT = "Une erreur est survenue lors de la vérification de la disponibilité.";
export const CHECK_AVAILABILITY_ERROR = CHECK_AVAILABILITY_ERROR_TEXT;

const CONFIRM_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de la vérification de la disponibilité.";
export const CONFIRM_RESERVATION_ERROR = CONFIRM_RESERVATION_ERROR_TEXT;

const CANCEL_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de l'annulation de votre réservation.";
export const CANCEL_RESERVATION_ERROR = CANCEL_RESERVATION_ERROR_TEXT;

const CONTACT_RESTAURANT_ERROR_TEXT = "Une erreur est survenue lors de l'envoi de votre demande.";
export const CONTACT_RESTAURANT_ERROR = CONTACT_RESTAURANT_ERROR_TEXT;

const CONFIRM_ORDER_ERROR_TEXT = "Une erreur est survenue lors de la vérification de la commande.";
export const CONFIRM_ORDER_ERROR = CONFIRM_ORDER_ERROR_TEXT;

const CHECK_DISTANCE_ERROR_TEXT = "Une erreur est survenue lors de la vérification de la distance de livraison.";
export const CHECK_DISTANCE_ERROR = CHECK_DISTANCE_ERROR_TEXT;

const GET_ORDER_SETTINGS_ERROR_TEXT = "Une erreur est survenue lors du chargement des paramètres.";
export const GET_ORDER_SETTINGS_ERROR = GET_ORDER_SETTINGS_ERROR_TEXT;

const CREATE_PAYMENT_INTENT_ERROR_TEXT = "Une erreur est survenue lors du chargement du moyen de paiement.";
export const CREATE_PAYMENT_INTENT_ERROR = CREATE_PAYMENT_INTENT_ERROR_TEXT;

const CREATE_PAYMENT_SOURCE_ERROR_TEXT = "Une erreur est survenue lors du chargement du moyen de paiement.";
export const CREATE_PAYMENT_SOURCE_ERROR = CREATE_PAYMENT_SOURCE_ERROR_TEXT;

const CREATE_UPON_PICKUP_PAYMENT_ERROR_TEXT = "Une erreur est survenue lors de la finalisation de la commande.";
export const CREATE_UPON_PICKUP_PAYMENT_ERROR = CREATE_UPON_PICKUP_PAYMENT_ERROR_TEXT;

const GET_CURRENT_ORDER_ERROR_TEXT = "Une erreur est survenue lors du chargement de votre commande.";
export const GET_CURRENT_ORDER_ERROR = GET_CURRENT_ORDER_ERROR_TEXT;

const CANCEL_ORDER_ERROR_TEXT = "Une erreur est survenue lors de l'annulation de votre commande.";
export const CANCEL_ORDER_ERROR = CANCEL_ORDER_ERROR_TEXT;

export const GET_DEFAULT_SURVEY_ERROR = "Une erreur est survenue lors de la récupération du questionnaire.";

export const ANSWER_SURVEY_ERROR = "Une erreur est survenue lors de l'envoi de votre réponse.";

export const ANSWER_BARESTHO_SURVEY_ERROR = "Une erreur est survenue lors de l'envoi de votre réponse.";

export const GET_SURVEYS_STATUS_ERROR = "Une erreur est survenue lors de la récupération des statuts des questionnaires.";


// WEBPACK FOOTER //
// ./src/errors.js